export enum UserType {
  EndUser = 1,
  Nutritionist,
  Company,
}
